import type { ReactElement } from 'react';
import { Button, Portal } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Text } from '../typography';

export const BackToTopButton = (): ReactElement => (
    <Portal>
        <Button
            data-testid="back-to-top-button"
            variant="newprimary-black"
            position="fixed"
            textTransform="none"
            height="auto"
            boxShadow="0 2px 10px 0 rgba(65, 64, 66, 0.14)"
            borderColor="slt-pepper.200"
            borderRadius={32}
            paddingInline={4}
            paddingY={2}
            left={0}
            right={0}
            bottom={5}
            width="fit-content"
            margin="auto"
            zIndex={1000}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
            <Text size="xs" style="bold" color="inherit">
                <FormattedMessage id="back.to.top" defaultMessage="Back to Top" />
            </Text>
        </Button>
    </Portal>
);
